import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        menuList:{},//导航列表
        offset:{},//富贵科技菜单偏移量（pc）
        winWidth:768,//屏幕宽度
        winScroll:0,//页面滚动
        dataInfo:{},//基础信息
    },
    mutations: {
        setMenu(state, data) {
            state.menuList = data;
        },
        setOffset(state, data) {
            state.offset = data;
        },
       setWidth(state,data){
            state.winWidth = data
        },
        setScroll(state,data){
            state.winScroll = data
        },
        setdataInfo(state,data){
            state.dataInfo = data
        }
    }

})